import namespace from '../../constants/namespace';

/**
 * @param name: if parent ? camelCase : PascalCase
 * @param parent PascalCase
 * @returns {string}
 */
const getComponentClassName = (name: string, parent?: string): string =>
  parent ? `${namespace}-${parent}-${name}` : `${namespace}-${name}`;

export default getComponentClassName;
